import withRouter from "hoc/withRouter";
import { Button, CircularProgress, IconButton, Pagination, TextField } from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import { useEffect, useState } from "react";
import { toDate } from "helpers/dateHelper";
import { toCurrencyFormat } from "helpers/utils";
import AppTable from "components/AppTable/AppTable";
import { Link } from "react-router-dom";
import { MdArticle } from "react-icons/md";
import { urlReplaceState } from "helpers/url";
import { useForm } from "react-hook-form";
import { LIMIT } from "data/consts";
import { OrderStatus } from "components/OrderStatus";
import { SUB_ORDER_TYPE } from "enums/enums";
import { useGetSubOrders } from "hooks/useGetSubOrders";

const columnConfig = [
    {
        key: 'id',
        label: '#',
        render: (b) => {
            return <Link className="color-blue" to={`/admin/sub-orders/view/${b.id}`}>
                {b.id}
            </Link>
        }
    },
    {
        key: 'createdAt',
        label: 'Дата создания',
        formatter: (v) => toDate(v)
    },
    {
        key: 'totalAmount',
        label: 'Общая стоимость',
        render: (i) => toCurrencyFormat(i.totalAmount, i.currency)
    },
    {
        key: 'status',
        label: 'Статус заказа',
        render: (i) => <OrderStatus status={i.status} subStatus={i.subStatus}></OrderStatus>
    },
    {
        key: 'customerID',
        label: 'Покупатель',
        render: (i) => {
            return <Link target="_blank" to={`/admin/customers/view/${i.customerID}`}>
                {i.customer?.lastName} {i.customer?.firstName}
            </Link>
        }
    },
    {
        key: 'customers',
        label: 'Туристы',
        render: (so) => {
            if (!so.orderItems) {
                return ""
            }
            if (so.orderItems?.length > 3) {
                return <span>Больше 3х туристов</span>
            }
            return <div className="gap-8">
                {so.orderItems?.map((oi, inx) => {
                    return inx !== so.orderItems.length - 1 ? <Link target="_blank" to={`/admin/customers/view/${oi.customerID}`}>
                        {oi.customer?.lastName} {oi.customer?.firstName}<span>, </span>
                    </Link> : <Link target="_blank" to={`/admin/customers/view/${oi.customerID}`}>
                        {oi.customer?.lastName}  {oi.customer?.firstName}
                    </Link>
                })}
            </div>
        }
    },
    {
        key: 'view',
        label: '',
        render: (so) => {
            return <div className="flex gap-8">
                <Link to={`/admin/sub-orders/view/${so.id}`}>
                    <IconButton size="small">
                        <MdArticle></MdArticle>
                    </IconButton>
                </Link>
            </div>
        }
    },
]

const SubOrdersList = ({ router: { queryParams } }) => {
    const [query, setQuery] = useState({
        page: queryParams.get("page") || 1,
        query: queryParams.get("query") || "",
        id: queryParams.get("id") || ""
    });

    const { data: subOrders, isLoading, error } = useGetSubOrders(localStorage.getItem("orgID"), query);

    const {
        handleSubmit,
        register,
        getValues,
    } = useForm({
        reValidateMode: "onChange",
        mode: "onChange",
        defaultValues: {
            id: ""
        }
    });

    useEffect(() => {
        // Используется для обновления состояние url
        urlReplaceState(null, query);
    }, [query]);

    const updateSearch = (params) => {
        setQuery({
            ...query,
            ...params,
        });
    };

    const onPageChanged = (e, _page) => {
        updateSearch({ page: _page })
    }

    const onSearch = () => {
        updateSearch({ id: getValues('id'), page: 1 })
    }

    function buildContent() {
        if (error) {
            return <div>{error}</div>
        }
        if (isLoading) {
            return <div className="text-center"><CircularProgress></CircularProgress></div>
        }


        // Количество страниц
        const pageCount = Math.ceil(subOrders?.count / LIMIT)
        const showPagination = pageCount > 1
        return <div>
            <AppTable data={subOrders?.rows} columnConfig={columnConfig}></AppTable>
            <div>
                {showPagination ? <Pagination className="m-t-32" page={query.page} count={pageCount} onChange={onPageChanged} /> : null}
            </div>
        </div>
    }
    return (
        <ListPage pageTitle="История заказов" pathToAdd={`../add`}>
            <div className="m-t-32">
                <form onSubmit={handleSubmit(onSearch)} className="m-b-32 flex align-center">
                    <TextField
                        type="search"
                        label="Поиск по номеру бронирования"
                        {...register('id')}
                        autoComplete="off"
                        className="m-w-100"
                        style={{ minWidth: 300 }}
                        onChange={(e) => {
                            if (e.target.value === "") {
                                updateSearch({
                                    id: '',
                                    page: 1
                                })
                            }
                        }}
                    ></TextField>
                    <Button type="submit">Поиск</Button>
                </form>
                {buildContent()}
            </div>
            {/* <pre>
                {JSON.stringify(watch())}
            </pre> */}
        </ListPage>

    );
};

export default withRouter(SubOrdersList);
